import { Sport } from '__generated__/globalTypes';
import { Color } from 'style/types';

const THRESHOLD_COLORS: { [key: string]: Color } = {
  veryLow: 'var(--c-score-veryLow)',
  low: 'var(--c-score-low)',
  mediumLow: 'var(--c-score-mediumLow)',
  medium: 'var(--c-score-medium)',
  mediumHigh: 'var(--c-score-mediumHigh)',
  high: 'var(--c-score-high)',
  max: 'var(--c-gradient-score-max)',
};

export type ScoreType = 'CARD_SCORE' | 'PLAYER_SCORE' | 'TEAM_SCORE';

const teamScoreThresholds = [
  [72.49, 'veryLow'],
  [147.49, 'low'],
  [222.49, 'mediumLow'],
  [197.49, 'medium'],
  [372.49, 'mediumHigh'],
] as const;

export const thresholdsBySport = {
  [Sport.FOOTBALL]: [
    [20, 'veryLow'],
    [35, 'low'],
    [50, 'mediumLow'],
    [60, 'medium'],
    [75, 'mediumHigh'],
  ] as const,
  [Sport.NBA]: [
    [4.49, 'veryLow'],
    [14.49, 'low'],
    [24.49, 'mediumLow'],
    [34.49, 'medium'],
    [49.49, 'mediumHigh'],
  ] as const,
  [Sport.BASEBALL]: [
    [2.49, 'veryLow'],
    [7.49, 'low'],
    [11.49, 'mediumLow'],
    [19.49, 'medium'],
    [29.49, 'mediumHigh'],
  ] as const,
} as const;
export const maxScoresBySport = {
  [Sport.FOOTBALL]: 100,
  [Sport.NBA]: 75,
  [Sport.BASEBALL]: 45,
};

export const findThresholdColor = (
  score: number,
  sport: Sport,
  type?: ScoreType
) => {
  let level;
  if (sport === Sport.FOOTBALL && type === 'TEAM_SCORE') {
    level = teamScoreThresholds.find(t => Number(t[0]) >= score)?.[1];
  } else if (score >= maxScoresBySport[sport]) {
    level = 'max';
  } else {
    level = thresholdsBySport[sport].find(t => t[0] >= score)?.[1];
  }

  return THRESHOLD_COLORS[level || 'high'];
};
